<div class="reset-password-container">
  <h2 class="reset-password-header">Reset Password</h2>
  <div *ngIf="loading" class="loading-overlay">
    <div class="spinner"></div>
  </div>
  <form *ngIf="!formHidden" [formGroup]="resetForm" (ngSubmit)="resetPassword()">
    <div class="form-group">
      <label>User Name:</label>
      <div class="form-row">
        <input formControlName="username" type="text" required />
      </div>
    </div>
    <div class="captcha-row">
      <span class="captcha-box">{{ captchaCode }}</span>
      <button type="button" (click)="generateCaptcha()" style="min-width: 0px !important; margin-top: 0px !important;" class="refresh-captcha" title="Refresh captcha">&#x21bb;</button>
      <input type="text" style="margin-bottom: 0px !important;" formControlName="captchaInput" maxlength="8" placeholder="Enter captcha" required class="captcha-input" />
      
    </div>
    <button *ngIf="!otpSent" type="button" (click)="sendOtp()" [disabled]="!resetForm.get('username')?.valid">Send OTP</button>
    <button *ngIf="otpSent" type="button" (click)="sendOtp()">Regenerate OTP</button>
    
    <div class="form-group" *ngIf="otpSent">
      <label>OTP:</label>
      <input formControlName="userEnteredOtp" type="text" required />
      <button type="button" (click)="verifyOtp()" [disabled]="!resetForm.get('userEnteredOtp')?.valid">Verify OTP</button>
      <div *ngIf="resetForm.get('userEnteredOtp')?.touched && resetForm.get('userEnteredOtp')?.invalid" class="error-message">
        <small *ngIf="resetForm.get('userEnteredOtp')?.errors?.required">OTP is required.</small>
      </div>
      <!-- <div *ngIf="isOtpExpired()" class="error-message">
        <small>OTP has expired. Please click Send OTP again.</small>
      </div> -->
    </div>
     <div *ngIf="otpMessage" [style.color]="otpMessageColor" class="otp-message">{{ otpMessage }}</div>
    
    <div class="form-group" *ngIf="otpVerified">
      <label>New Password:</label>
      <div class="password-container">
        <input
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="password"
          required
          placeholder="Password"
        />
        <span class="eye" (click)="hidePassword = !hidePassword">👁</span>
      </div>
      <div *ngIf="resetForm.get('password')?.touched && resetForm.get('password')?.invalid" class="error-message">
        <small *ngIf="resetForm.get('password')?.errors?.required">Password is required.</small>
      </div>
    </div>
    <div class="form-group" *ngIf="otpVerified">
      <label>Confirm Password:</label>
      <div class="password-container">
        <input
          [type]="hideConfirmPassword ? 'password' : 'text'"
          formControlName="confirmPassword"
          required
          placeholder="Confirm Password"
        />
        <span class="eye" (click)="hideConfirmPassword = !hideConfirmPassword">👁</span>
      </div>
      <div *ngIf="resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched" class="error-message">
        <small>Passwords do not match.</small>
      </div>
    </div>
    <div class="password-hint" *ngIf="otpVerified">
      <small>
        <strong>Password requirements:</strong><br>
        <span [ngClass]="{
          'password-rule-valid': isMinLength() && (resetForm.get('password')?.touched || passwordValue.length > 0),
          'password-rule-invalid': !isMinLength() && (resetForm.get('password')?.touched || passwordValue.length > 0)
        }">Minimum {{ passwordMinLength }} characters.</span><br>
        <span [ngClass]="{
          'password-rule-valid': isNoSpaces() && (resetForm.get('password')?.touched || passwordValue.length > 0),
          'password-rule-invalid': !isNoSpaces() && (resetForm.get('password')?.touched || passwordValue.length > 0)
        }">Spaces are not allowed.</span><br>
        <span [ngClass]="{
          'password-rule-valid': hasNumber() && (resetForm.get('password')?.touched || passwordValue.length > 0),
          'password-rule-invalid': !hasNumber() && (resetForm.get('password')?.touched || passwordValue.length > 0)
        }">At least one numeric (1-9) character.</span><br>
        <span [ngClass]="{
          'password-rule-valid': hasUpper() && (resetForm.get('password')?.touched || passwordValue.length > 0),
          'password-rule-invalid': !hasUpper() && (resetForm.get('password')?.touched || passwordValue.length > 0)
        }">At least one capital letter.</span><br>
        <span [ngClass]="{
          'password-rule-valid': hasSpecial() && (resetForm.get('password')?.touched || passwordValue.length > 0),
          'password-rule-invalid': !hasSpecial() && (resetForm.get('password')?.touched || passwordValue.length > 0)
        }">At least one special character.</span>
      </small>
    </div>
    <button type="submit"
      *ngIf="otpVerified"
      [disabled]="!resetForm.get('password')?.valid || !resetForm.get('confirmPassword')?.valid || resetForm.hasError('passwordMismatch') || resetForm.get('password')?.hasError('passwordInvalid')"
    >Reset Password</button>
  </form>
  <div *ngIf="resetMessage" [style.color]="resetMessageColor" class="reset-message" [innerHTML]="resetMessage"></div>
</div>

